module.exports = __webpack_public_path__ + "static/media/logo-onogate-white.f789efcf.png";